import React, { useContext } from "react";
import { UnitPurchaseContext } from "../../UnitModal";

const SelectHotel = () => {
  const UnitsData = useContext(UnitPurchaseContext);

  const setHotelName = (hotelName) => {
      UnitsData.setHotelName(hotelName);
      UnitsData.updateUnitStep("Select Hotel Customer Name");
  };

  return (
    <div className="row">
      <div className="col-sm-12 text-center my-4">
        <div className="d-inline-flex gap-4">
          <button
            type="button"
            className="btn btn-secondary btn-lg"
            onClick={() => setHotelName("W")}
          >
            <h1>
              <i className="fas fa-hotel" />
            </h1>
            Palm Pavilion
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectHotel;
